/**
  Author: Lokesh Arora - lokesh.arora@enabledata.com
  Purpose: Users add/edit form fields
  Date: April 25, 2020
**/

import React from 'react';
import {
  Grid,
  TextField,
  makeStyles,
  Button,
  FormHelperText,
  Select,
  InputLabel,
  FormControl,
  MenuItem,
} from '@material-ui/core';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { useStoreState, useStoreActions } from 'easy-peasy';
import { Typography } from '@material-ui/core';
import { TagChips } from '../../../submodule';

import { stringConstants } from '../../../constants/stringConstants';
import { currentUserEntity } from '../../../constants/applicationConstants';
import LocalStorageService from '../../../services/localStorage';
const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(2),
    marginLeft: '0px',
    width: '100%',
  },
  mainPadding: {
    padding: '0 20px',
  },
  attachFile: {
    paddingTop: '30px !important',
  },
  headerRightPlusIcon: {
    textAlign: 'end',
  },
}));

const ImportFormFields = (props) => {
  const classes = useStyles();
  const { cancelClick, onDone, importJob } = props;
  // const [importFile, setImportFile] = React.useState({});
  const [jobPK, setJobPk] = React.useState('');
  const commonAction = useStoreActions((actions) => actions.common);
  const importAction = useStoreActions((actions) => actions.import);
  const importState = useStoreState((state) => state.import);
  const [selectedImportType, setSelectedImportType] = React.useState('');
  const [filePath, setFilePath] = React.useState({});
  const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1, 3}\.[0-9]{1, 3}\.[0-9]{1, 3}\.[0-9]{1, 3}\.[0-9]{1, 3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  // const [fullDescFile, setFullDescFile] = React.useState({});
  // const [shortDescFile, setShortDescFile] = React.useState({});
  let localStorage = {};
  try {
    localStorage = JSON.parse(LocalStorageService.getUserInfo());
  } catch (error) {
    console.log('error - ', error)
  }

  const userRole = localStorage;
  let pAdminImportOpts = [
    {
      "PK": "code_type_cpt",
      "current_status": "APPROVED",
      "schema_path": "",
      "import_code": "code_type_cpt",
      "title": "CPT Codes",
      'show_full_and_short_desc': true
    },
    {
      "PK": "code_type_hcpc",
      "current_status": "APPROVED",
      "schema_path": "",
      "import_code": "code_type_hcpc",
      "title": "HCPC Codes"
    },
    {
      "PK": "code_type_cptpla",
      "current_status": "APPROVED",
      "schema_path": "",
      "import_code": "code_type_cptpla",
      "title": "CPTPLA Codes"
    },
    {
      "PK": "ICD-10-CM",
      "current_status": "APPROVED",
      "schema_path": "",
      "import_code": "ICD-10-CM",
      "title": "ICD 10 CM"
    }
  ]
  let importJobMappings = {}

  for (let i = 0; i < importState?.importTypes?.length; i++) {
    importJobMappings[importState.importTypes[i].PK] = importState.importTypes[i];
  }

  if (
    userRole.roles &&
    userRole.roles.title.toLowerCase() ===
    currentUserEntity.platformAdminTitle
  ) {
    for (let i = 0; i < pAdminImportOpts.length; i++) {
      importJobMappings[pAdminImportOpts[i].PK] = pAdminImportOpts[i];
    }
  }
  const fieldData = {
    import_type: '',
    sourceFile: '',
    full_desc_file: '',
    short_desc_file: '',
    consumer_desc_file: '',
    jobName: '',
    // description: '',
    headerRow: 'No',
    notificationEmail: [],
    year: '',
  };

  const schema = Yup.object().shape({
    import_type: Yup.string().required(stringConstants.requiredValidationMsg),
    sourceFile: Yup.string().when('import_type', {
      is: (val) => {
        if (importJobMappings[val] && importJobMappings[val].show_full_and_short_desc) {
          return false
        }
        return true;
      },
      then: Yup.string().required(stringConstants.requiredValidationMsg),
      otherwise: Yup.string().notRequired()
    }),
    full_desc_file: Yup.string().when('import_type', {
      is: (val) => importJobMappings[val] && importJobMappings[val].show_full_and_short_desc,
      then: Yup.string().test('at-least-one-file', 'At least one file must be selected', function (value) {
        const { full_desc_file, short_desc_file, consumer_desc_file } = this.parent;
        return !!(full_desc_file || short_desc_file || consumer_desc_file);
      }),
      otherwise: Yup.string().notRequired()
    }),
    short_desc_file: Yup.string(),
    consumer_desc_file: Yup.string(),
    jobName: Yup.string().required(stringConstants.requiredValidationMsg),
    // description: Yup.string().required(stringConstants.requiredValidationMsg),
    headerRow: Yup.string().when('import_type', {
      is: (val) => {
        if (
          userRole.roles &&
          userRole.roles.title.toLowerCase() ===
          currentUserEntity.platformAdminTitle
        ) {
          return true;
        } else {
          return false;
        }
      },
      then: Yup.string().notRequired(),
      otherwise: Yup.string().required(stringConstants.requiredValidationMsg)
    }),
    notificationEmail: Yup.array()
    .of(
      Yup.string().matches(
        emailRegex,
        stringConstants.validEmailMsg,
      ).max(250, 'Email should be less than 250 characters'),
    )
    .typeError('A valid email required e.g. abc@example.com'),
    year: Yup.string().test('Year validation', stringConstants.requiredValidationMsg, function (value) {
      if (userRole.roles && userRole.roles.title.toLowerCase() === currentUserEntity.platformAdminTitle && !value) {
        return false;
      }
      return true;
    }),
  });

  const processResponseData = (data) => {
    let dataObject = {
      columns: [],
      data: [],
      ...data
    }
    let preview = data.preview;
    try {
      for (let i = 0; i < preview.length; i++) {
        let record = preview[i];
        let rowObject = {};
        for (let j = 0; j < record.length; j++) {
          let title = record[j].title;
          if (i === 0) {
            dataObject.columns.push({
              'headerName': title,
              'field': title,
              'width': 250
            })
          }
          rowObject[title] = record[j].value === "" ? ' - ' : record[j].value;
        }
        rowObject['id'] = i;
        dataObject.data.push(rowObject);
      }
    } catch (error) {
      console.log('error ', error);
    }
    return dataObject;
  }

  const onFormSubmit = async (values, { resetForm, setErrors }) => {
    try {
      const {
        import_type,
        jobName,
        // description,
        headerRow,
        notificationEmail,
        year,
      } = values;
      if (!importJobMappings[import_type]?.show_full_and_short_desc) {
        if (!filePath.sourceFile) {
          setErrors({ sourceFile: stringConstants.uploadFileValidationErrMsg });
          return;
        }
      }
      // Create an object of formData
      const formData = {
        file_path: filePath.sourceFile,
        title: jobName,
        description: "Test description",
        import_type: import_type,
        header_row: headerRow,
        notification_email: notificationEmail,
        full_desc_file: filePath.full_desc_file,
        short_desc_file: filePath.short_desc_file,
        consumer_desc_file: filePath.consumer_desc_file,
        PK: jobPK,
      };

      if (userRole.roles && userRole.roles.title.toLowerCase() === currentUserEntity.platformAdminTitle) {
        // Update the formData object
        formData.year = year;
        importAction
          .pa_upload(formData)
          .then(function (response) {
            commonAction.setSubmitSnackbar({
              status: true,
              messages: jobPK == "" ? stringConstants.addedRecordMsg : stringConstants.updateMsg,
            });
            if (response.data && response.data.data && response.data.data.job && response.data.data.job.PK) {
              setJobPk(response.data.data.job.PK);
              importAction.setJobList([response.data.data.job, ...importState.jobList]);
            }
            let formattedGridData = processResponseData(response.data.data);
            response.data.data['formattedGridData'] = formattedGridData;
            onDone(response.data.data);
          })
          .catch(function (error) {
            if (error.response && error.response.data && error.response.data.error) {
              const outputErrors = {};
              const errorlist = error.response.data.error;
              for (const item in errorlist) {
                outputErrors[Object.keys(errorlist[item])] =
                  errorlist[item][Object.keys(errorlist[item])];
              }
              setErrors(outputErrors);
            }
          });
      } else {
        // Update the formData object
        importAction
          .upload(formData)
          .then(function (response) {
            commonAction.setSubmitSnackbar({
              status: true,
              messages: jobPK == "" ? stringConstants.addedRecordMsg : stringConstants.updateMsg,
            });
            if (response.data && response.data.data && response.data.data.job && response.data.data.job.PK) {
              setJobPk(response.data.data.job.PK);
            }
            let formattedGridData = processResponseData(response.data.data);
            response.data.data['formattedGridData'] = formattedGridData;
            onDone(response.data.data);
          })
          .catch(function (error) {
            if (error.response && error.response.data && error.response.data.error) {
              const outputErrors = {};
              const errorlist = error.response.data.error;
              for (const item in errorlist) {
                outputErrors[Object.keys(errorlist[item])] =
                  errorlist[item][Object.keys(errorlist[item])];
              }
              setErrors(outputErrors);
            }
          });
      }
    } catch (err) {
      commonAction.setSubmitSnackbar({
        status: true,
        messages: stringConstants.NetWorkError,
        error: true,
      });
    }
  };

  React.useEffect(() => {
    if (userRole.roles && userRole.roles.title.toLowerCase() != currentUserEntity.platformAdminTitle) {
      importAction.getImportTypes();
    }
  }, []);

  // React.useEffect(() => {
  //   if (importFile?.size > 0) {
  //     uploadSourceFile(importFile, 'sourceFile');
  //   }
  // }, [importFile])

  // React.useEffect(() => {
  //   if (fullDescFile?.size > 0) {
  //     uploadSourceFile(fullDescFile, 'full_desc_file');
  //   }
  // }, [fullDescFile])

  // React.useEffect(() => {
  //   if (shortDescFile?.size > 0) {
  //     uploadSourceFile(shortDescFile, 'short_desc_file');
  //   }
  // }, [shortDescFile])

  // Uploads File to the S3 Bucket
  const uploadSourceFile = (file, name) => {
    importAction
      .getPreSignedUrl({
        filename: file.name,
        filetype: file.type,
        operation_type: 'UPLOAD',
      })
      .then(function (response) {
        // setFilePath(response.data.data.file_path);
        setFilePath({ ...filePath, [name]: response.data.data.file_path });
        // Create an object of formData
        importAction
          .uploadToS3({
            url: response.data.data.url,
            file: file,
          })
          .then((result) => {
            if (result.status == 200) {
              commonAction.setSubmitSnackbar({
                status: true,
                messages: stringConstants.fileUploadSuccessMsg,
              });
            } else {
              commonAction.setSubmitSnackbar({
                status: true,
                messages: stringConstants.fileUploadFailureMsg,
                error: true,
              });
            }
          });
      })
      .catch(function (error) {
        commonAction.setSubmitSnackbar({
          status: true,
          messages: error.response && error.response.status === 422 ? stringConstants.fileUploadTypeErrorMsg : stringConstants.fileUploadFailureMsg,
          error: true,
        });
      });
  };

  return (
    <>
      <Formik
        initialValues={fieldData}
        onSubmit={onFormSubmit}
        validationSchema={schema}
        enableReinitialize={true}
      >
        {(formikProps) => {
          const {
            values,
            touched,
            errors,
            setFieldValue,
            handleChange,
            handleBlur,
            handleSubmit,
            setFieldTouched,
            isValid,
            dirty,
          } = formikProps;
          return (
            <>
              <Grid container style={{margin: '30px 0px 30px'}}>
                <Grid style={{position: 'relative'}} item md={12} className={`${classes.mainPadding}`}>
                  <Typography variant="h6" component="h6" style={{marginBottom: '30px'}}>
                    Import
                  </Typography>
                </Grid>
                <Grid item md={12} className={`${classes.mainPadding}`}>
                  <form onSubmit={handleSubmit} noValidate>
                    <Grid container spacing={2}>
                      <Grid item md={6}>
                        <FormControl
                          required
                          variant="outlined"
                          fullWidth
                        >
                          <InputLabel id="demo-simple-select-outlined-label">
                            Import Type
                          </InputLabel>
                          <Select
                            required
                            labelId="demo-simple-select-outlined-label"
                            id="demo-simple-select-outlined"
                            placeholder="Import Type"
                            name="import_type"
                            value={values.import_type}
                            //onChange={handleChange}
                            error={errors.import_type && touched.import_type}
                            onChange={(e, v) => { 
                              setFieldValue('import_type', e.target.value, true);
                              setSelectedImportType(e.target.value);
                            }}
                            label="Import Type"
                          >
                            {importState.importTypes &&
                              importState.importTypes.map((value, index) => {
                                return (
                                  <MenuItem key={index} value={value.PK}>
                                    {value.title}
                                  </MenuItem>
                                );
                              })}
                            {userRole.roles &&
                              userRole.roles.title.toLowerCase() ===
                              currentUserEntity.platformAdminTitle && pAdminImportOpts.map((value, index) => {
                                return (
                                  <MenuItem key={index} value={value.PK}>
                                    {value.title}
                                  </MenuItem>
                                );
                              })}

                          </Select>
                          <FormHelperText
                            className={
                              errors.import_type &&
                                touched.import_type &&
                                errors.import_type
                                ? 'Mui-error'
                                : ''
                            }
                          >
                            {errors.import_type &&
                              touched.import_type &&
                              errors.import_type}
                          </FormHelperText>
                        </FormControl>
                      </Grid>
                      <Grid item md={6}>
                        <TextField
                          required
                          fullWidth
                          id="jobName"
                          name="jobName"
                          label="Job Name"
                          variant="outlined"
                          value={values.jobName}
                          //onChange={handleChange}
                          onChange={(e, v) => {
                            setFieldValue('jobName', e.target.value, true);
                          }}
                          onBlur={handleBlur}
                          error={errors.jobName && touched.jobName}
                          helperText={
                            errors.jobName && touched.jobName && errors.jobName
                          }
                        ></TextField>
                      </Grid>
                      <Grid item md={userRole.roles && userRole.roles.title.toLowerCase() === currentUserEntity.platformAdminTitle ? 4 : 6}>
                        <FormControl
                          required={userRole.roles &&
                            userRole.roles.title.toLowerCase() !=
                            currentUserEntity.platformAdminTitle}
                          variant="outlined"
                          fullWidth
                        >
                          <InputLabel id="demo-simple-select-outlined-label">
                            Header Row
                          </InputLabel>
                          <Select
                            labelId="demo-simple-select-outlined-label"
                            id="demo-simple-select-outlined"
                            placeholder="Header Row"
                            name="headerRow"
                            value={values.headerRow}
                            onChange={handleChange}
                            label="Header Row"
                          >
                            <MenuItem value="Yes">
                              Yes
                            </MenuItem>
                            <MenuItem value="No">
                              No
                            </MenuItem>
                          </Select>
                          <FormHelperText
                            className={
                              errors.headerRow &&
                                touched.headerRow &&
                                errors.headerRow
                                ? 'Mui-error'
                                : ''
                            }
                          >
                            {errors.headerRow &&
                              touched.headerRow &&
                              errors.headerRow}
                          </FormHelperText>
                        </FormControl>
                      </Grid>
                      <Grid item
                        md={userRole.roles && userRole.roles.title.toLowerCase() === currentUserEntity.platformAdminTitle ? 4 : 6}
                      >
                        {/*<TextField
                          fullWidth
                          id="notificationEmail"
                          name="notificationEmail"
                          label="Notification Email"
                          variant="outlined"
                          value={values.notificationEmail}
                          //onChange={handleChange}
                          onChange={(e, v) => {
                            setFieldValue(
                              'notificationEmail',
                              e.target.value,
                              true,
                            );
                          }}
                          onBlur={handleBlur}
                          error={
                            errors.notificationEmail &&
                            touched.notificationEmail
                          }
                          helperText={
                            errors.notificationEmail &&
                            touched.notificationEmail &&
                            errors.notificationEmail
                          }
                        ></TextField>*/}
                        <TagChips
                          initData={values.notificationEmail}
                          labelId="allowed-domains-label"
                          id="allowed-domains"
                          placeholder={`Notification Email`}
                          name="notificationEmail"
                          errors={errors}
                          touched={touched}
                          setTouched={setFieldTouched}
                          setFieldValue={setFieldValue}
                          maxTags={10}
                          textCase="lowercase"
                        />
                        <FormHelperText
                          className={
                            errors.notificationEmail
                              ? 'Mui-error'
                              : ''
                          }
                        >
                          {errors.notificationEmail ? errors.notificationEmail : `Input an email (abc@example.com) and hit enter`}

                        </FormHelperText>
                      </Grid>
                      {userRole.roles && userRole.roles.title.toLowerCase() === currentUserEntity.platformAdminTitle && (
                        <Grid item md={4}>
                          <TextField
                            fullWidth
                            required
                            id="year"
                            name="year"
                            label="Year"
                            variant="outlined"
                            value={values.year}
                            //onChange={handleChange}
                            onChange={(e, v) => {
                              setFieldValue(
                                'year',
                                e.target.value,
                                true,
                              );
                            }}
                            onBlur={handleBlur}
                            error={
                              errors.year &&
                              touched.year
                            }
                            helperText={
                              errors.year &&
                              touched.year &&
                              errors.year
                            }
                          ></TextField>
                        </Grid>
                      )}
                    </Grid>
                    <Grid container spacing={2}>
                      {importJobMappings[selectedImportType]?.show_full_and_short_desc ? (
                        <>
                          <Grid item md={1}>
                            <Typography style={{ marginTop: '5px' }}>Full Description</Typography>
                          </Grid>
                          <Grid item md={3}>
                            <TextField
                              required
                              type="file"
                              inputProps={{ accept: '.csv, .txt' }}
                              fullWidth
                              id="full_desc_file"
                              name="full_desc_file"
                              variant="outlined"
                              onChange={(event) => {
                                uploadSourceFile(event.target.files[0], 'full_desc_file');
                                handleChange(event);
                              }}
                              onClick={(event) => {
                                event.target.value = null;
                                setFieldValue('full_desc_file', '');
                              }}
                              error={errors.full_desc_file && touched.full_desc_file}
                              helperText={
                                errors.full_desc_file &&
                                touched.full_desc_file &&
                                errors.full_desc_file
                              }
                            ></TextField>
                          </Grid>
                          <Grid item md={1}>
                            <Typography style={{ marginTop: '5px' }}>Short Description</Typography>
                          </Grid>
                          <Grid item md={3}>
                            <TextField
                              required
                              type="file"
                              inputProps={{ accept: '.csv, .txt' }}
                              fullWidth
                              id="short_desc_file"
                              name="short_desc_file"
                              variant="outlined"
                              onChange={(event) => {
                                uploadSourceFile(event.target.files[0], 'short_desc_file');
                                handleChange(event);
                              }}
                              onClick={(event) => {
                                event.target.value = null;
                                setFieldValue('short_desc_file', '');
                              }}
                              error={errors.short_desc_file && touched.short_desc_file}
                              helperText={
                                errors.short_desc_file &&
                                touched.short_desc_file &&
                                errors.short_desc_file
                              }
                            ></TextField>
                          </Grid>
                          <Grid item md={1}>
                            <Typography style={{ marginTop: '5px' }}>Consumer Description</Typography>
                          </Grid>
                          <Grid item md={3}>
                            <TextField
                              required
                              type="file"
                              inputProps={{ accept: '.csv, .txt' }}
                              fullWidth
                              id="consumer_desc_file"
                              name="consumer_desc_file"
                              variant="outlined"
                              onChange={(event) => {
                                uploadSourceFile(event.target.files[0], 'consumer_desc_file');
                                handleChange(event);
                              }}
                              onClick={(event) => {
                                event.target.value = null;
                                setFieldValue('consumer_desc_file', '');
                              }}
                              error={errors.consumer_desc_file && touched.consumer_desc_file}
                              helperText={
                                errors.consumer_desc_file &&
                                touched.consumer_desc_file &&
                                errors.consumer_desc_file
                              }
                            ></TextField>
                          </Grid>
                        </>
                      ) : (
                        <>
                          <Grid item md={1}>
                            <Typography style={{marginTop: '20px'}}>Source File</Typography>
                          </Grid>
                          <Grid item md={5}>
                            <TextField
                              type="file"
                              inputProps={{ accept: '.csv, .txt' }}
                              margin="normal"
                              fullWidth
                              id="sourceFile"
                              name="sourceFile"
                              variant="outlined"
                              onChange={(event) => {
                                uploadSourceFile(event.target.files[0], 'sourceFile');
                                handleChange(event);
                              }}
                              onClick={(event) => {
                                event.target.value = null;
                                setFieldValue('sourceFile', '');
                              }}
                              error={errors.sourceFile && touched.sourceFile}
                              helperText={
                                errors.sourceFile &&
                                touched.sourceFile &&
                                errors.sourceFile
                              }
                            ></TextField>
                          </Grid>
                        </>
                      )}
                    </Grid>
                    <Grid
                      container
                      direction="row"
                      justifyContent="center"
                      alignItems="center"
                      spacing={2}
                      style={{marginTop: '30px'}}
                    >
                      <Grid item>
                        <Button
                          variant="contained"
                          color="secondary"
                          onClick={cancelClick}
                          className={classes.button}
                        >
                          Cancel
                        </Button>
                      </Grid>
                      {jobPK !== '' && (
                        <Grid item>
                          <Button
                            variant="contained"
                            color="primary"
                            onClick={() => cancelClick('preview')}
                            className={classes.button}
                          >
                            Preview
                          </Button>
                        </Grid>
                      )}
                      {jobPK === '' ? (
                        <Grid item>
                          <Button
                            type="submit"
                            variant="contained"
                            color="primary"
                            className={''}
                            disabled={!isValid || !dirty}
                          >
                            Save
                          </Button>
                        </Grid>
                      ) : (
                        <Grid item>
                          <Button
                            // disabled={disableImport}
                            variant="contained"
                            color="primary"
                            className={''}
                            onClick={importJob}
                          >
                            Import
                          </Button>
                        </Grid>
                      )}
                    </Grid>
                  </form>
                </Grid>
              </Grid>
            </>
          );
        }}
      </Formik>
    </>
  );
};

export default ImportFormFields;
